import React from 'react';
import styled from 'styled-components';
import { FooterNavigationItems } from './FooterNavigationItems';
import { H4 } from '../Typography';
const Container = styled.div `
  width: 100%;
  border-top: 2px solid ${({ theme }) => theme.primaryBlack};
  padding-top: 50px;
`;
const StyledContainer = styled.ul `
  display: flex;
  margin: 0;
  padding-left: 0;
  justify-content: center;
`;
const ItemContainer = styled.li `
  position: relative;
  z-index: auto;
  list-style: none;
  width: 255px;
  &:not(:last-of-type) {
    margin-right: ${({ length }) => (length === 2 || length === 3 ? `79px` : length === 4 ? `30px` : `30px`)};
  }
`;
const LabelContainer = styled.div `
  border-bottom: 2px solid ${({ theme }) => theme.primaryBlack};
  margin-bottom: 25px;
  padding-bottom: 25px;
  min-height: 52px;
`;
const LabelCategory = styled(H4) `
  margin-bottom: 25px;
  color: ${({ theme }) => theme.trueBlack};
`;
export const DesktopFooterNavigation = ({ footerItems }) => {
    if (!footerItems)
        return null;
    const navSection = footerItems.find((item) => item.displayName === 'NavigationSection');
    const navItems = navSection && navSection.fields && navSection.fields.items;
    const NavItems = ({ items }) => {
        return (React.createElement(React.Fragment, null, items.map(({ fields }, index) => {
            return index <= 3 ? React.createElement(Items, { fields: fields, key: index }) : null;
        })));
    };
    const length = navItems && navItems.length;
    const Items = ({ fields }) => {
        const { categoryTitle, items } = fields;
        return (React.createElement(ItemContainer, { length: length },
            React.createElement("nav", null,
                React.createElement(LabelContainer, null, categoryTitle && React.createElement(LabelCategory, { field: categoryTitle })),
                React.createElement(FooterNavigationItems, { items: items }))));
    };
    return (React.createElement(Container, null,
        React.createElement(StyledContainer, { className: "styled-container" },
            React.createElement(NavItems, { items: navItems }))));
};
